/** Подписи значений здания — как `help` enum монолита (`cian/business_shopping_centers/domain/enums.py`) */

export const BUILDING_CLASS_LABELS: Partial<Record<string, string>> = {
  a: 'A',
  aPlus: 'A+',
  b: 'B',
  bPlus: 'B+',
  bMinus: 'B-',
  c: 'C',
  cPlus: 'C+',
  d: 'D',
};

export const SHOPPING_CENTER_SCALE_LABELS: Partial<Record<string, string>> = {
  microdistrict: 'Микрорайонный',
  okrug: 'Окружной',
  district: 'Районный',
  regional: 'Региональный',
  superOkrug: 'Суперокружной',
  superRegional: 'Суперрегиональный',
};

export const TRANSPORT_TYPE_LABELS: Partial<Record<string, string>> = {
  walk: 'Пешком',
  transport: 'На транспорте',
};

export const PARKING_TYPE_LABELS: Partial<Record<string, string>> = {
  roof: 'На крыше',
  underground: 'Подземная',
  ground: 'Наземная',
  multilevel: 'Многоуровневая',
  open: 'Открытая',
  spontaneous: 'Спонтанная',
};

export const ACCESS_TYPE_LABELS: Partial<Record<string, string>> = {
  free: 'Свободный',
  passSystem: 'Пропускная система',
};
